import { SocialPublishFormActions } from '@app/modules/social-export/components/SocialPublishFormActions';
import { TikTokPlatform } from '@app/modules/social-export/domain/platforms';
import { useWatch } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { tiktokDisclosureMessages } from './disclosure/tiktok-disclosure-messages';

/**
 * TikTok publish form actions with disclosure tooltip.
 * Renders the submit button and shows a tooltip when the button is disabled
 * because commercial content disclosure is on but no option (your brand / third party / both) is selected.
 */
export function TikTokPublishFormActions() {
  const { $t } = useIntl();
  const discloseVideoContent = useWatch({ name: 'discloseVideoContent' });
  const brandContent = useWatch({ name: 'brandContent' });
  const brandOrganic = useWatch({ name: 'brandOrganic' });
  const missingDisclosureSelection =
    Boolean(discloseVideoContent) && !brandContent && !brandOrganic;

  return (
    <SocialPublishFormActions
      platform={TikTokPlatform}
      disableSubmitIfInvalid
      submitDisabledTooltip={
        missingDisclosureSelection ? $t(tiktokDisclosureMessages.selectAtLeastOneHint) : undefined
      }
    />
  );
}
